import React from "react";
import ImageListItem from "@mui/material/ImageListItem";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./Components.css";
export default function Images() {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1500 },
      items: 5,
      slidesToSlide: 2,
    },

    desktop: {
      breakpoint: { max: 1500, min: 950 },
      items: 4,
      slidesToSlide: 2,
    },
    tablet: {
      breakpoint: { max: 950, min: 550 },
      items: 2,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 550, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };
  return (
    <Carousel
      dotListClass="custom-dot-list-style"
      itemClass="carousel-item-padding-20-px"
      containerClass="carousel-container"
      autoPlay={true}
      rtl={true}
      focusOnSelect={true}
      removeArrowOnDeviceType={["tablet", "mobile"]}
      autoPlaySpeed={2500}
      infinite={true}
      responsive={responsive}
    >
      {itemData.map((item, index) => (
        <a
          key={index}
          href="https://instagram.com/noa_talel?igshid=MzRlODBiNWFlZA=="
          className="link-insta"
          target="_blank"
          rel="noreferrer"
        >
          <ImageListItem key={item.img}>
            <img
              className="images-look"
              src={`${item.img}?w=824&h=824&fit=crop&auto=format`}
              srcSet={`${item.img}?w=824&h=824&fit=crop&auto=format&dpr=2 2x`}
              alt={item.title}
              loading="lazy"
              style={{
                height: 450,
                margin: 0,
              }}
            />
          </ImageListItem>
        </a>
      ))}
    </Carousel>
  );
}

const itemData = [
  {
    img: "/images/gallery/1de33a46b3b497287de85a498142a0c9fd713859.webp",
    title: "1",
  },
  {
    img: "/images/gallery/1e2c1b9d7441e80716312715c870689f5b357d8f.webp",
    title: "2",
  },
  {
    img: "/images/gallery/6d0817a203a8b68100a9fe2a7751b0f891531eaa.webp",
    title: "3",
  },
  {
    img: "/images/gallery/d54394590076a326407298064218a4cfc346f5bc.webp",
    title: "4",
  },
  {
    img: "/images/gallery/79e69596fb2de72a1302c14a6cb0caf42513dc20.webp",
    title: "5",
  },
  {
    img: "/images/gallery/42b73a4679d0afd3efe23483f774c34df993a68b.webp",
    title: "6",
  },
  {
    img: "/images/gallery/e59ee830784672195cc61b392afa55519df914dd.webp",
    title: "",
  },
  {
    img: "/images/gallery/ac7074c679a89c33a105df84622b31a08a1e17f9.webp",
    title: "",
  },
  {
    img: "/images/gallery/f6f372da50d28f84b2d9d9da09069f2efd7dbb62.webp",
    title: "",
  },
  {
    img: "/images/gallery/efa7905abd46509f48b960979ef1035fe030c956.webp",
    title: "1",
  },
  {
    img: "/images/gallery/c756412d184c989bd79d040c05c42123a03cc4fc.webp",
    title: "",
  },
  {
    img: "/images/gallery/d9c54dd1ffc88c2dab9b7431d125150502b83013.webp",
    title: "",
  },
  {
    img: "/images/gallery/cb1778a11f3656df4858f9d892b412ddd50ab425.webp",
    title: "",
  },
  {
    img: "/images/gallery/6193ae6f8b876123541bad47ea8818fafb6c6000.webp",
    title: "",
  },
  {
    img: "/images/gallery/c1889bb8d92f42c1c86f2703318413955bd8048a.webp",
    title: "10/",
  },
  {
    img: "/images/gallery/23603951d1c89dca432a94df9278d4d2705f5f85.webp",
    title: "11/",
  },
  {
    img: "/images/gallery/6281f5be51efc853abe8da7b7432fad6383ea0d0.webp",
    title: "12/",
  },
  {
    img: "/images/gallery/aa9692d5a3de7854492741324e52e9fdb7d91ce1.webp",
    title: "13/",
  },
  {
    img: "/images/gallery/8479a6b5fa915223d1a5d9fb37dfb6ba0dcdccfa.webp",
    title: "14/",
  },
  {
    img: "/images/gallery/e4c14a3d5163db497d02f86e2297cf0b62e37dc3.webp",
    title: "15",
  },
  {
    img: "/images/gallery/f90fde0370d6ab392078a387183c7661e18be34a.webp",
    title: "16",
  },
];